import { useTranslation } from "react-i18next";
import Range from "../../components/Range";
import { IconBil } from "../../components/icons";
import { useWizard } from "./WizardContext";

export default function Step3Ude() {
  const { t } = useTranslation();
  const { state, dispatch } = useWizard();
  return (
    <div>
      <span className="font-mono text-xs uppercase tracking-[0.14em] text-accent-deep">{t("step3.kicker")}</span>
      <h2 className="mt-2.5 text-[clamp(26px,4.4vw,40px)]">{t("step3.title")}</h2>
      <p className="mb-6 mt-2 max-w-[54ch] text-ink-soft">{t("step3.help")}</p>

      <Range
        min={0} max={80} step={5} value={state.ude}
        onChange={(v) => dispatch({ type: "set", field: "ude", value: v })}
        label={t("step3.udeLabel")} display={`${state.ude} %`} lo={t("step3.udeLo")} hi={t("step3.udeHi")}
      />

      <div className="mt-5 flex gap-3 rounded-m border border-accent bg-accent-tint px-4 py-3.5 text-[14px] text-accent-ink">
        <IconBil className="mt-px h-5 w-5 shrink-0" />
        <span>{t("step3.hint")}</span>
      </div>
    </div>
  );
}
